import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.li`
  width: 100%;
  height: 40px;
  min-height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme }) => theme.colors.background};

  &:hover {
    background-color: ${({ theme }) => darken(0.025, theme.colors.background)};
  }

  &:not(:last-child) {
    margin-bottom: 5px;
  }
`;

export const Label = styled.span`
  width: fit-content;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textBackground};
`;
